"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _product = require("@/api/product");
var _validate = require("@/utils/validate");
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _creatAttr = _interopRequireDefault(require("../components/creatAttr"));
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _auth = require("@/utils/auth");
var _edit = _interopRequireDefault(require("@/components/Category/edit.vue"));
var _merchant = require("@/api/merchant");
var _systemForm = require("@/api/systemForm");
var _useProduct2 = require("@/hooks/use-product");
var _product2 = _interopRequireDefault(require("@/mixins/product"));
var _default2 = require("./default");
var _addLimitDialog = _interopRequireDefault(require("../components/addLimitDialog"));
var _addBackDialog = _interopRequireDefault(require("../components/addBackDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
var _default = exports.default = {
  name: 'creatCanteenProduct',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  mixins: [_product2.default],
  //此js存放团购券的部分函数方法
  components: {
    edit: _edit.default,
    Tinymce: _index.default,
    creatAttr: _creatAttr.default,
    addLimitDialog: _addLimitDialog.default,
    addBackDialog: _addBackDialog.default
  },
  data: function data() {
    return {
      //批量添加规格的值
      oneFormBatch: [{
        image: '',
        price: void 0.01,
        cost: void 0.01,
        otPrice: void 0.01,
        stock: void 0,
        barCode: '',
        itemNumber: '',
        weight: void 0,
        volume: void 0,
        brokerage: void 0,
        brokerageTwo: void 0,
        cdkeyId: null,
        cdkeyLibraryName: '',
        expand: '',
        vipPrice: void 0
      }],
      frontDomain: localStorage.getItem('frontDomain'),
      htmlKey: 0,
      formThead: Object.assign({}, _default2.objTitle),
      form: 2,
      url: '',
      copyConfig: {},
      labelarr: [],
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      isCopy: this.$route.params.isCopy === '1' ? true : false,
      //是否是采集
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, _default2.defaultObj.attrValueList[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, _default2.defaultObj.attrValueList[0])],
      // 多规格
      manyTabTit: {},
      manyTabDate: {},
      // 生成规格表格中的头部标题
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: '1',
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入团购券名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择平台分类',
          trigger: 'change'
        }],
        cateIds: [{
          required: true,
          message: '请选择商户团购券分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入团购券简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传缩略图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择团购券规格',
          trigger: 'change'
        }],
        // 品牌功能已隐藏 - brandId validation disabled
        brandId: [{
          required: false,
          message: '请选择团购券品牌',
          trigger: 'change'
        }],
        deliveryMethodList: [{
          required: true,
          message: '请选择配送方式',
          type: 'array',
          trigger: 'change'
        }],
        'ext.reservation': [{
          required: true,
          message: '请选择是否需要预约',
          trigger: 'change'
        }],
        'ext.topKnow': [{
          required: true,
          message: '请输入顶部须知',
          trigger: 'blur'
        }],
        'ext.limitUse': [{
          required: true,
          message: '请输入使用限制',
          trigger: 'blur'
        }],
        'ext.productReturn': [{
          required: true,
          message: '请输入退货规则描述',
          trigger: 'blur'
        }],
        'ext.limitRule': [{
          required: true,
          message: '请输入使用限制规则描述',
          trigger: 'blur'
        }],
        lastDay: [{
          required: true,
          message: '请输入有效天数',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '天数必须大于0',
          trigger: 'change'
        }]
      },
      tempRoute: {},
      keyNum: 0,
      isShowAttr: false,
      guaranteeList: [],
      brandList: [],
      search: {
        limit: this.$constants.page.limit[0],
        page: 1,
        cid: '',
        brandName: ''
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      isShowGroup: 'alone',
      guaranteeGroupList: [],
      guaranteeNew: [],
      guaranteeName: [],
      multiples: true,
      productClassify: [],
      //平台团购券分类
      productType: [{
        tit: '普通团购券',
        id: 0,
        tit2: '实体货物'
      }],
      upload: {
        videoIng: false // 是否显示进度条；
      },
      videoLink: '',
      //视频地址
      progress: 10,
      // 进度条默认0
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {},
        biztype: {
          name: '产品分类',
          value: 1,
          shortName: '产品'
        } // 统一主业务中的目录类型
      },
      //团购券分类
      isSwitch: false,
      //商户开关
      productSwitch: false,
      //团购券是否需要审核 true需要审核，false免审
      canSel: true,
      // 规格图片添加判断
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      limitArr: [],
      //限购规则列表
      backArr: [],
      // 退货规则列表
      limitVisible: false,
      backVisible: false
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    next();
  },
  computed: _objectSpread(_objectSpread({
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, (0, _vuex.mapState)({
    systemFormList: function systemFormList(state) {
      return state.mobildConfig.systemFormList;
    }
  })), (0, _vuex.mapGetters)(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  created: function created() {
    var _this2 = this;
    this.labelarr = [];
    this.$nextTick(function () {
      _this2.$refs.formValidate && _this2.$refs.formValidate.resetFields(); // 确保 ref 已加载后再调用
    });
    this.formValidate.type = 2; //团购券类型
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    var _this3 = this;
    this.formValidate.attrs = [];
    this.formValidate.sliderImages = [];
    this.labelarr = [];
    this.$nextTick(function () {
      if (_this3.$refs.formValidate) {
        _this3.$refs.formValidate.resetFields();
      }
    });
    if ((0, _permission.checkPermi)(['merchant:plat:product:category:cache:tree'])) this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
    if ((0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.$store.dispatch('product/getMerProductBrand');
    if (!localStorage.getItem('shippingTemplates')) this.$store.dispatch('product/getShippingTemplates');
    if ((0, _permission.checkPermi)(['merchant:plat:product:guarantee:list'])) this.getProductGuarantee();
    if ((0, _permission.checkPermi)(['merchant:product:guarantee:group:list'])) this.getGuaranteeGroupList();
    if (!localStorage.getItem('systemFormList') && (0, _permission.checkPermi)(['merchant:system:form:page'])) this.getSystemFormList();
    this.setTagsViewTitle();
    if (this.$route.params.id && this.$route.params.id != 0) {
      // if (checkPermi(['merchant:product:info']))
      this.getInfo();
    } else {
      this.isShowAttr = true;
    }
    if (this.isCopy && (0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.getCopyConfig();
    this.productClassify = this.addDisabled(this.merPlatProductClassify);
    this.getProductAuditSwitchInfo();
    this.getbacklist();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    hasExtProperty: function hasExtProperty(prop) {
      return this.formValidate.ext && this.formValidate.ext[prop] !== undefined;
    },
    // 获取退货/限购规则列表
    getbacklist: function getbacklist() {
      var _this4 = this;
      (0, _product.currentlimitListApi)().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                console.log(res);
                _this4.limitArr = res.list;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      (0, _product.currentlreturnListApi)().then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                console.log(res);
                _this4.backArr = res.list;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 切换默认选中规格
    changeDefault: function changeDefault(e, index) {
      // 一个开启 其他关闭
      this.ManyAttrValue.map(function (item, i) {
        if (i !== index) {
          item.isDefault = false;
        }
      });
      if (e) this.ManyAttrValue[index].isShow = true;
    },
    // 回调规格生成表格数据
    changeManyAttrValue: function changeManyAttrValue(e) {
      // rows数组第一项 新增默认数据 oneFormBatch
      this.ManyAttrValue = e;
    },
    changeIsEditVal: function changeIsEditVal() {
      this.isEditAttrVal = false;
    },
    //批量清空规格中的批量数据
    handleBatchDel: function handleBatchDel() {
      this.oneFormBatch = [{
        image: '',
        price: void 0.01,
        cost: void 0.01,
        otPrice: void 0.01,
        stock: void 0,
        weight: void 0,
        volume: void 0,
        brokerage: void 0,
        brokerageTwo: void 0,
        cdkeyId: null,
        cdkeyLibraryName: '',
        barCode: '',
        itemNumber: '',
        expand: '',
        vipPrice: void 0
      }];
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    },
    //系统表单数据
    getSystemFormList: function () {
      var _getSystemFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$systemFormPage, list;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _systemForm.systemFormPageApi)({
                page: 1,
                limit: 999
              });
            case 1:
              _yield$systemFormPage = _context3.v;
              list = _yield$systemFormPage.list;
              this.$store.commit('mobildConfig/SET_SystemForm', list);
              localStorage.setItem('systemFormList', JSON.stringify(list));
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getSystemFormList() {
        return _getSystemFormList.apply(this, arguments);
      }
      return getSystemFormList;
    }(),
    //获取商户端商户团购券审核开关信息
    getProductAuditSwitchInfo: function getProductAuditSwitchInfo() {
      var _this5 = this;
      (0, _merchant.productAuditSwitchInfoApi)().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this5.isSwitch = res.isSwitch;
                _this5.productSwitch = res.productSwitch;
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    //添加团购券分类
    handleAddMenu: function handleAddMenu(rowData) {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.data = {};
      this.editDialogConfig.visible = true;
    },
    hideEditDialog: function hideEditDialog() {
      var _this6 = this;
      this.editDialogConfig.prent = {};
      this.editDialogConfig.type = 0;
      this.editDialogConfig.visible = false;
      setTimeout(function () {
        _this6.$store.dispatch('product/getMerProductClassify');
      }, 200);
    },
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(param) {
        var formData, data, loading, res, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context5.p = 1;
              _context5.n = 2;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 2:
              res = _context5.v;
              this.upload.videoIng = true;
              this.videoLink = res.url;
              this.progress = 100;
              loading.close();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t = _context5.v;
              loading.close();
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleUploadForm(_x4) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    // 删除视频；
    delVideo: function delVideo() {
      this.$set(this, 'videoLink', '');
    },
    //限制平台团购券分类只能选择第三级
    addDisabled: function addDisabled(dropdownList) {
      var _this7 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            isShow: e.isShow
          };
          if (!e.childList && (e.level === 1 || e.level === 2)) {
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              disabled: true
            });
          }
          if (e.childList) {
            var childList = _this7.addDisabled(e.childList);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              childList: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        return [];
      }
      return list;
    },
    // 生成团购券表单
    addProduct: function addProduct() {
      var _this8 = this;
      if (this.url) {
        this.formValidate.content = '';
        this.loading = true;
        this.fullscreenLoading = true;
        this.copyConfig.copyType == 1 ? (0, _product.copyProductApi)({
          url: this.url
        }).then(function (res) {
          _this8.getData(res, 'copy');
          _this8.isShowAttr = true;
          _this8.loading = false;
          _this8.fullscreenLoading = false;
        }).catch(function () {
          _this8.loading = false;
          _this8.fullscreenLoading = false;
        }) : (0, _product.importProductApi)({
          url: this.url,
          form: this.form
        }).then(function (res) {
          _this8.getData(res, 'copy');
          _this8.isShowAttr = true;
          _this8.loading = false;
          _this8.fullscreenLoading = false;
        }).catch(function () {
          _this8.loading = false;
          _this8.fullscreenLoading = false;
        });
      } else {
        this.$message.warning('请输入链接地址！');
      }
    },
    /**
     * 复制团购券转图片路径
     * @param sliderImage轮播图, attrValue规格
     */
    getShopImg: function () {
      var _getShopImg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(sliderImage, attrValue) {
        var _this9 = this;
        var imgList, attrs, ShopImg, result;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              imgList = _toConsumableArray(JSON.parse(sliderImage));
              attrValue.map(function (item) {
                return imgList.push(item.image);
              });
              attrs = _toConsumableArray(new Set(imgList));
              ShopImg = [];
              attrs.map(function (item) {
                ShopImg.push({
                  key: item,
                  img: item
                });
              });
              _context6.n = 1;
              return this.getShopImgUpload(ShopImg, []);
            case 1:
              result = _context6.v;
              this.formValidate.images = this.formValidate.images.map(function (item, index) {
                if (result[index].key && item === result[index].key) {
                  return result[index].img;
                } else {
                  _this9.formValidate.images.splice(index, 1);
                }
              });
              this.ManyAttrValue.map(function (item, index) {
                result.map(function (items, index) {
                  if (items.key && item.image === items.key) {
                    return item.image = items.img;
                  }
                });
              });
              this.fullscreenLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getShopImg(_x5, _x6) {
        return _getShopImg.apply(this, arguments);
      }
      return getShopImg;
    }(),
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(attrs, arr) {
        var key, res, _t2, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _t2 = _regeneratorKeys(attrs);
            case 1:
              if ((_t3 = _t2()).done) {
                _context7.n = 3;
                break;
              }
              key = _t3.value;
              _context7.n = 2;
              return this.getImgData(attrs[key].img || attrs[key].sattDir);
            case 2:
              res = _context7.v;
              arr.push({
                key: attrs[key].img || attrs[key].imgsattDir,
                img: res
              });
              _context7.n = 1;
              break;
            case 3:
              return _context7.a(2, arr);
          }
        }, _callee7, this);
      }));
      function getShopImgUpload(_x7, _x8) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    /**
     * 复制团购券图片路径请求接口
     * @param imgUrl
     * @returns {Promise<any>}
     */
    getImgData: function getImgData(imgUrl) {
      var _this0 = this;
      return new Promise(function (resolve, reject) {
        shopImgUploadApi({
          imgUrl: imgUrl,
          respType: 1,
          uploadType: 1
        }).then(function (res) {
          if (res.errcode > 0) {
            _this0.fullscreenLoading = false;
            _this0.$message.error(res.errmsg);
            resolve('');
          } else {
            resolve(res.img_info.temp_img_url);
          }
        });
      });
    },
    getCopyConfig: function getCopyConfig() {
      var _this1 = this;
      (0, _product.copyConfigApi)().then(function (res) {
        _this1.copyConfig = res;
      });
    },
    changeGuarantee: function changeGuarantee(val) {
      var _this10 = this;
      if (val) {
        this.guaranteeName = [];
        if (this.isShowGroup === 'combination') {
          var guaranteeGroupids = [];
          var data = this.guaranteeGroupList.filter(function (item) {
            return val.includes(item.id);
          });
          if (data.length) {
            data[0].guaranteeList.map(function (item) {
              return item.isShow && guaranteeGroupids.push(item.gid);
            });
          }
          this.formValidate.guaranteeIds = guaranteeGroupids.toString();
          this.guaranteeList.map(function (item) {
            guaranteeGroupids.map(function (j) {
              if (item.id === j) _this10.guaranteeName.push(item.name);
            });
          });
        }
      } else {
        this.guaranteeName = [];
        this.$set(this.formValidate, 'guaranteeIdsList', null);
      }
    },
    //选择保障服务模式
    onchangeIsShow: function onchangeIsShow() {
      this.multiples = !this.multiples;
      this.guaranteeName = [];
      this.formValidate.guaranteeIds = '';
      if (this.isShowGroup === 'combination') {
        this.guaranteeNew = this.guaranteeGroupList;
        this.$set(this.formValidate, 'guaranteeIdsList', '');
      } else {
        this.$set(this.formValidate, 'guaranteeIdsList', []);
        this.guaranteeNew = this.guaranteeList;
      }
    },
    // 服务组合列表
    getGuaranteeGroupList: function getGuaranteeGroupList() {
      var _this11 = this;
      (0, _product.guaranteeListApi)().then(function (res) {
        _this11.guaranteeGroupList = res;
      });
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    // 保障服务列表
    getProductGuarantee: function getProductGuarantee() {
      var _this12 = this;
      (0, _product.productGuaranteeApi)().then(function (res) {
        _this12.guaranteeList = res.filter(function (item) {
          return item.isShow;
        });
        _this12.guaranteeNew = _this12.guaranteeList;
      });
    },
    onChangeCategory: function onChangeCategory() {
      this.formValidate.brandId = '';
      this.brandList = [];
      // this.getbrandList();
      this.brandList.push({
        name: '其他',
        id: 0
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getbrandList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this13 = this;
      this.loading = true;
      this.search.brandName = query;
      this.search.page = 1;
      setTimeout(function () {
        _this13.loading = false;
        _this13.getbrandList(); // 请求接口
      }, 200);
    },
    // 品牌列表
    getbrandList: function getbrandList() {
      var _this14 = this;
      this.search.cid = this.formValidate.categoryId;
      (0, _product.brandListApi)(this.search).then(function (res) {
        _this14.totalPage = res.totalPage;
        _this14.total = res.total;
        _this14.brandList = _this14.brandList.concat(res.list);
      });
    },
    proving1: function proving1(e) {
      this.formValidate.sort = e.target.value.replace(/[^\.\d]/g, '');
      this.formValidate.sort = e.target.value.replace('.', '');
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;
      this.$modalCoupon('wu', this.keyNum += 1, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isDisabled ? '团购券详情' : '团购券团购券';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this15 = this;
      this.fullscreenLoading = true;
      (0, _product.productDetailApi)(this.$route.params.id).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(res) {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                _context8.n = 1;
                return _this15.getData(res, 'add');
              case 1:
                _this15.isShowAttr = true;
                _this15.fullscreenLoading = false;
              case 2:
                return _context8.a(2);
            }
          }, _callee8);
        }));
        return function (_x9) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this15.fullscreenLoading = false;
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      this.currentTab = (Number(this.currentTab) + 1).toString();
    },
    //保存接口数据更新
    getFromData: function getFromData() {
      var _this16 = this;
      if (this.formValidate.specType && this.formValidate.attrs.length < 1) return this.$message.warning('请填写多规格属性！');
      if (this.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.videoLink);
      }
      if (this.isShowGroup === 'alone') this.formValidate.guaranteeIds = this.formValidate.guaranteeIdsList.join(',');
      var attrValueListData = [];
      if (this.formValidate.specType) {
        //规格值
        this.formValidate.attrList = this.formValidate.attrs.map(function (item, index) {
          return {
            attributeName: item.value,
            isShowImage: item.add_pic == 1 ? true : false,
            id: 0,
            sort: index + 1,
            optionList: item.detail.map(function (arr, idx) {
              return {
                image: arr.image,
                optionName: arr.value,
                sort: idx + 1
              };
            })
          };
        });
        //表格数据
        var ManyAttrValues = _toConsumableArray(this.ManyAttrValue);
        attrValueListData = ManyAttrValues;
        attrValueListData.shift();
        for (var i = 0; i < attrValueListData.length; i++) {
          var attrValues = _objectSpread({}, attrValueListData[i].attrValueShow);
          this.$set(attrValueListData[i], 'attrValue', JSON.stringify(attrValues)); //
        }
      } else {
        this.formValidate.attrList = [{
          attributeName: '规格',
          attrValues: '默认',
          isShowImage: false,
          optionList: [{
            optionName: '默认',
            id: 0,
            image: '',
            sort: 1
          }]
        }];
        this.OneattrValue.map(function (item) {
          _this16.$set(item, 'attrValue', JSON.stringify({
            规格: '默认'
          }));
        });
      }
      console.log(this.labelarr);
      this.formValidate.ext.reservation = '否';
      var data = _objectSpread(_objectSpread({}, this.formValidate), {}, {
        cateId: 0,
        brandId: 0,
        merchantType: 20,
        keyword: this.labelarr.join(','),
        sliderImage: JSON.stringify(this.formValidate.sliderImages),
        deliveryMethod: this.formValidate.deliveryMethodList.join(','),
        systemFormId: this.formValidate.systemFormId ? this.formValidate.systemFormId : 0,
        attrValueList: this.formValidate.specType ? attrValueListData : this.OneattrValue,
        tempId: this.formValidate.type != 0 ? 0 : this.formValidate.tempId
      });
      return data;
    },
    //是否自动上架
    automaticListing: function automaticListing() {
      var _this17 = this;
      this.$confirm(this.productSwitch ? '审核通过之后是否自动上架？' : '操作之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        customClass: 'deleteConfirm'
      }).then(function () {
        _this17.formValidate.isAutoUp = true;
        _this17.postData();
      }).catch(function (action) {
        if (action === 'cancel') {
          _this17.formValidate.isAutoUp = false;
          _this17.postData();
          // 调用取消按钮的方法
        } else if (action === 'close') {
          // 调用关闭按钮的方法
        }
      });
    },
    //保存并审核
    handleSubmitAndAudit: function handleSubmitAndAudit(name) {
      var _this18 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          //  this.getFromData();
          _this18.formValidate.isAutoSubmitAudit = true;
          _this18.automaticListing();
        } else {
          if (!_this18.formValidate.name || !_this18.formValidate.cateId || !_this18.formValidate.keyword || !_this18.formValidate.unitName || !_this18.formValidate.intro || !_this18.formValidate.image || !_this18.formValidate.sliderImages) {
            _this18.$message.warning('请填写完整团购券信息！');
          }
        }
      });
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this19 = this;
      console.log(this.formValidate);
      // let data = this.getFromData();
      this.formValidate.keywords = 0;
      this.formValidate.cateId = 0;
      this.$refs[name].validate(function (valid, invalidFields) {
        if (valid) {
          // this.getFromData();
          //免审团购券，保存的时候弹出上架弹窗，条件：店铺开启 && 店铺免审
          if (_this19.isSwitch && !_this19.productSwitch) {
            _this19.formValidate.isAutoSubmitAudit = false;
            _this19.automaticListing();
          } else {
            _this19.formValidate.isAutoUp = false;
            _this19.formValidate.isAutoSubmitAudit = false;
            _this19.postData();
          }
        } else {
          Object.keys(invalidFields).forEach(function (field) {
            console.log("\u5B57\u6BB5\u540D: ".concat(field, ", \u9519\u8BEF\u4FE1\u606F:"), invalidFields[field].map(function (err) {
              return err.message;
            }));
          });
          if (!_this19.formValidate.name || !_this19.formValidate.cateId || !_this19.formValidate.keyword || !_this19.formValidate.unitName || !_this19.formValidate.intro || !_this19.formValidate.image || !_this19.formValidate.sliderImages) {
            _this19.$message.warning('请填写完整团购券信息！');
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this20 = this;
      this.loadingBtn = true;
      var data = this.getFromData();
      parseFloat(this.$route.params.id) > 0 ? (0, _product.productUpdateApi)(data).then(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(res) {
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                _this20.$message.success('编辑成功');
                setTimeout(function () {
                  _this20.$router.push({
                    path: '/canteen-product/list'
                  });
                }, 500);
                _this20.closeSelectedTag();
                _this20.loadingBtn = false;
              case 1:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function (_x0) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this20.loadingBtn = false;
      }) : (0, _product.productCreateApi)(data).then(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(res) {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                _this20.$message.success('新增成功');
                setTimeout(function () {
                  _this20.$router.push({
                    path: '/canteen-product/list'
                  });
                }, 500);
                _this20.closeSelectedTag();
                _this20.loadingBtn = false;
              case 1:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x1) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this20.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref7) {
        var visitedViews = _ref7.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    updateLimitVisible: function updateLimitVisible(e) {
      this.limitVisible = e;
      this.getbacklist();
    },
    updateBackVisible: function updateBackVisible(e) {
      this.backVisible = e;
      this.getbacklist();
    }
  }
};